export const Close = "Close";
export const PanelResizeLabel = "Resize panel";
export const PanelResizeValueText = "Panel width {0} pixels";
export const Resize = "Resize";
export const SizeFormat = "Height {0}, Width {1}";
